import { useAuth0 } from '@auth0/auth0-react';
import { Hyperlink } from '@strata/react-hyperlink';
import { LoggedOutScreen, Subheading } from '@strata/react-page-templates';

import { Header } from 'components/header/Header';

export const LoggedOut = () => {
    const { loginWithRedirect } = useAuth0();
    return (
        <>
            <Header />
            <LoggedOutScreen
                appName="Real Time Auth"
                logInOnClick={() => loginWithRedirect()}
                additionalContent={
                    <>
                        <Subheading text="Interested In Access?" />
                        <p>
                            Free Market Health&apos;s Real Time Auth application is currently only
                            available to select authorized users.
                        </p>
                        <p>
                            Thank you for your interest in our application. Please keep an eye on
                            our{' '}
                            <Hyperlink
                                linkText="company website"
                                navUrl="https://www.freemarkethealth.com/"
                            />{' '}
                            for updates from Free Market Health.
                        </p>
                    </>
                }
            />
        </>
    );
};
